import { IFlowLogItem } from '@/types/report'

export const initialState: FlowLogState = {
  isLoadingFlowLog: false,
  isLoadingFlowLogError: false,

  currentFlowLogData: undefined,
  selectedPipeId: undefined,
}

export interface FlowLogState {
  isLoadingFlowLog: boolean
  isLoadingFlowLogError: boolean

  currentFlowLogData?: FlowLogData | null
  selectedPipeId?: number
}

export type FlowLogData = {
  id: number
  result: {
    items: IFlowLogItem[]
  }
}
